import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { USER_ROLE } from '../../constants'
import { useCountryCode, useStmCampaignCode } from '../../hooks'
import { AutocompleteMerchant } from './AutocompleteMerchant'

export const MerchantSelector = () => {
  const countryCode = useCountryCode()
  const { projectCode, campaignId, campaignCode } = useStmCampaignCode()
  const { destructuredData: userInfo } = useApiCampaignMember({ code: campaignCode ?? undefined })
  const isShopManager = !!userInfo?.roles.includes(USER_ROLE.SHOP_MANAGER)

  if (!projectCode || !campaignId || !campaignCode || !isShopManager) return null

  return (
    <HStack gap={2} alignItems="center">
      <Text color={colors.grey800}>你正以</Text>
      <AutocompleteMerchant
        key={campaignId}
        projectCode={projectCode}
        countryCode={countryCode}
        campaignId={campaignId}
        campaignCode={campaignCode}
      />
      <Text color={colors.grey800}>身份採購</Text>
    </HStack>
  )
}
